import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/charts/page.js");
